export default __webpack_public_path__ + "67fd8d4ac1ddac24d3126421826d3b23.png";